import _extends from "@babel/runtime/helpers/extends";
export const getExpiresAt = maxAge => Date.now() + maxAge;
export const setExpiresAt = (slice, maxAge) => slice.expiresAt === null ? _extends({}, slice, {
  expiresAt: getExpiresAt(maxAge)
}) : slice;